import type { ReactNode } from 'react';

interface UDFieldProps {
    label: string;
    children: ReactNode;
    hint?: string;
    count?: number;
}

// Shared field wrapper for the user drawer's form rows - label (+ optional
// count badge), the control, and an optional hint line below it.
export function UDField({ label, children, hint, count }: UDFieldProps) {
    return (
        <label className="flex flex-col gap-1.5">
            <span className="text-[12px] font-semibold text-gray-500 flex items-center gap-1.5">
                {label}
                {count != null && <span className="text-gray-400 font-medium">({count})</span>}
            </span>
            {children}
            {hint && <span className="text-[11px] text-gray-400">{hint}</span>}
        </label>
    );
}
